import request from '../utils/request';

// 分页查询售后服务配置
export function pageAfterSaleServiceConfigs(params) {
  return request({
    url: '/after-sale-service-config/list',
    method: 'get',
    params: {
      page: params.page || 1,
      pageSize: params.pageSize || 10,
      name: params.name,
      ...params
    }
  });
}

// 根据ID获取售后服务配置详情
export function getAfterSaleServiceConfigById(id) {
  return request({
    url: `/after-sale-service-config/${id}`,
    method: 'get'
  });
}

// 新增售后服务配置
export function addAfterSaleServiceConfig(data) {
  return request({
    url: '/after-sale-service-config/add',
    method: 'post',
    data: {
      name: data.name,
      description: data.description,
      supportsReturn: data.supportsReturn,
      supportsExchange: data.supportsExchange,
      supportsRefundOnly: data.supportsRefundOnly,
      returnPeriodDays: data.returnPeriodDays,
      supportsSevenDayReturn: data.supportsSevenDayReturn,
      returnInstructions: data.returnInstructions,
      isEnabled: data.isEnabled || 'ENABLED'
    }
  });
}

// 更新售后服务配置
export function updateAfterSaleServiceConfig(data) {
  return request({
    url: '/after-sale-service-config/update',
    method: 'put',
    data: {
      id: data.id,
      name: data.name,
      description: data.description,
      supportsReturn: data.supportsReturn,
      supportsExchange: data.supportsExchange,
      supportsRefundOnly: data.supportsRefundOnly,
      returnPeriodDays: data.returnPeriodDays,
      supportsSevenDayReturn: data.supportsSevenDayReturn,
      returnInstructions: data.returnInstructions,
      isEnabled: data.isEnabled
    }
  });
}

// 删除售后服务配置
export function deleteAfterSaleServiceConfig(id) {
  return request({
    url: `/after-sale-service-config/${id}`,
    method: 'delete'
  });
}
